import React from "react";

import { type Opportunity } from "@entities";
import { type EntityFilter } from "remult";

/** מספר טלפון מוקד התמיכה - לשימוש בקישור ווצאפ בלבד (לא לחיוג) */
export const WEME_SUPPORT_PHONE = "+972528336438";
/** קישור ווצאפ לתמיכה טכנית */
export const WEME_SUPPORT_WHATSAPP_URL = "https://wa.me/972528336438";
/** טקסט CTA באפליקציה - בלי URL גולמי (לחיצה פותחת ווצאפ) */
export const WEME_SUPPORT_WHATSAPP_CTA_TEXT = "כתבו לנו בווצאפ לתמיכה טכנית";
/** שורת CTA להודעות SMS / שרת - כוללת קישור להעתקה */
export const WEME_SUPPORT_WHATSAPP_CTA = `${WEME_SUPPORT_WHATSAPP_CTA_TEXT}: ${WEME_SUPPORT_WHATSAPP_URL}`;
/** תווית כפתור / לינק באפליקציה */
export const WEME_SUPPORT_WHATSAPP_BUTTON_LABEL =
  "כתבו לתמיכה הטכנית בווצאפ";
/** טקסט מקדים שנפתח בצ׳אט הווצאפ */
export const WEME_SUPPORT_WHATSAPP_PREFILL =
  "שלום, אשמח לעזרה טכנית באפליקציה";

/** סוגי דיווח לרעה – ערכים תואמים ל-enum IssueType ב-DB */
export const ISSUE_TYPE = [
  "UNPROFESSIONAL_CONDUCT",
  "MISLEADING_PROMISES",
  "POOR_COMMUNICATION",
  "UNQUALIFIED_LEAD",
] as const;

export const ISSUE_TYPE_HEB: Record<(typeof ISSUE_TYPE)[number], string> = {
  UNPROFESSIONAL_CONDUCT: "יחס והתנהגות",
  MISLEADING_PROMISES: "המשימה לא התאימה",
  POOR_COMMUNICATION: "בעיות בתיאום או בתקשורת",
  UNQUALIFIED_LEAD: "אחר",
};

export const REQUEST_DELETED_REASON_MASSAGE = {
  USER_NOT_TRUSTED: "הבקשה נדחתה בשל בעיות אמינות. לפרטים נוספים כתבו לנו בווצאפ",
  USER_DID_NOT_ANSWER: "הבקשה בוטלה לאחר שלא השבת לנסיון ההתקשרות שלנו. ניתן להגיש בקשה חדשה בכל עת",
  INVALID_REQUEST_DETAILS: "הבקשה בוטלה בשל פרטים לא תקינים. אנא הגש בקשה חדשה עם הפרטים הנכונים",
  REQUEST_NO_LONGER_RELEVANT: "הבקשה בוטלה כיוון שכבר לא רלוונטית. ניתן להגיש בקשה חדשה לפי הצורך",
  DUPLICATE_REQUEST: "הבקשה בוטלה כיוון שקיימת בקשה דומה. אנא בדוק את הבקשות הפעילות שלך",
  INSUFFICIENT_INFORMATION: "הבקשה בוטלה בשל מידע חסר. אנא הגש בקשה חדשה עם כל הפרטים הנדרשים",
  REQUEST_VIOLATES_POLICY: "הבקשה בוטלה כיוון שהיא מפרה את תנאי השימוש והמדיניות שלנו",
  USER_NOT_VERIFIED: "הבקשה בוטלה כיוון שהחשבון לא אומת. אנא השלם את תהליך האימות",
  SUSPICIOUS_ACTIVITY: "הבקשה בוטלה בשל פעילות חריגה. לפרטים נוספים כתבו לנו בווצאפ",
  REQUEST_EXPIRED: "הבקשה בוטלה כיוון שפג התוקף. ניתן להגיש בקשה חדשה",
  TECHNICAL_ISSUE: "הבקשה בוטלה בשל בעיה טכנית. נשמח לעזור בווצאפ",
  USER_REQUESTED_CANCELLATION: "הבקשה בוטלה לפי בקשתך. ניתן להגיש בקשה חדשה בכל עת",
  ADMINISTRATIVE_DECISION: "הבקשה בוטלה בהחלטה מנהלית. לפרטים נוספים כתבו לנו בווצאפ",
  REQUEST_NOT_APPROVED: "הבקשה לא אושרה ולא תוכל להתקיים. ניתן להגיש בקשה חדשה",
  USER_BLOCKED: "הבקשה בוטלה כיוון שהחשבון חסום. לפרטים נוספים כתבו לנו בווצאפ",
  DATA_INCONSISTENCY: "הבקשה בוטלה בשל אי התאמה בנתונים. אנא הגש בקשה חדשה עם נתונים מעודכנים",
  FRAUD_DETECTED: "הבקשה בוטלה בשל חשד לפעילות לא תקינה. לפרטים נוספים כתבו לנו בווצאפ",
} as const;

export const REQUEST_DELETED_REASON = [
  "USER_NOT_TRUSTED",
  "USER_DID_NOT_ANSWER",
  "INVALID_REQUEST_DETAILS",
  "REQUEST_NO_LONGER_RELEVANT",
  "DUPLICATE_REQUEST",
  "INSUFFICIENT_INFORMATION",
  "REQUEST_VIOLATES_POLICY",
  "USER_NOT_VERIFIED",
  "SUSPICIOUS_ACTIVITY",
  "REQUEST_EXPIRED",
  "TECHNICAL_ISSUE",
  "USER_REQUESTED_CANCELLATION",
  "ADMINISTRATIVE_DECISION",
  "REQUEST_NOT_APPROVED",
  "USER_BLOCKED",
  "DATA_INCONSISTENCY",
  "FRAUD_DETECTED",
] as const;

export const REQUEST_DELETED_REASON_HEB = {
  USER_NOT_TRUSTED: "המשתמש לא אמין",
  USER_DID_NOT_ANSWER: "המשתמש לא ענה",
  INVALID_REQUEST_DETAILS: "פרטי הבקשה לא תקינים",
  REQUEST_NO_LONGER_RELEVANT: "הבקשה כבר לא רלוונטית",
  DUPLICATE_REQUEST: "בקשה כפולה",
  INSUFFICIENT_INFORMATION: "מידע לא מספק",
  REQUEST_VIOLATES_POLICY: "הבקשה מפרה את תנאי השימוש והמדיניות שלנו",
  USER_NOT_VERIFIED: "החשבון לא אומת",
  SUSPICIOUS_ACTIVITY: "פעילות חריגה",
  REQUEST_EXPIRED: "פג התוקף",
  TECHNICAL_ISSUE: "בעיה טכנית",
  USER_REQUESTED_CANCELLATION: "ביקשת ביטול",
  ADMINISTRATIVE_DECISION: "החלטה מנהלית",
  REQUEST_NOT_APPROVED: "הבקשה לא אושרה",
  USER_BLOCKED: "החשבון חסום",
  DATA_INCONSISTENCY: "אי התאמה בנתונים",
  FRAUD_DETECTED: "חשד לפעילות לא תקינה",
} as const;

export const GENDER_LITERAL = ["MALE", "FEMALE", "OTHER"] as const;
export const GENDER_TO_HEB = {
  MALE: "זכר",
  FEMALE: "נקבה",
  OTHER: "אחר",
};
export const REPEAT_TYPES = ["WEEKS", "MONTHS", "CUSTOM", "NO_REPEAT"] as const;
export const WEEK_DAYS = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
] as const;

/** תיאור זמן (מועד גמיש) - תואם לאדמין (`DateAndHoursRange`), לאפליקציה ול־API */
export const TIME_DESCRIPTION_MAX_LENGTH = 35;

/** כותרת משימה למתנדבים - תואם לאדמין (`InfoForUser`) ולפרמוט AI */
export const OPPORTUNITY_TITLE_MAX_LENGTH = 50;

/** תיאור ההתנדבות / הבקשה למתנדבים - תואם לאדמין (`InfoForUser`), ל־weme-app ול־API */
export const VOLUNTEER_DESCRIPTION_MIN_LENGTH = 50;
export const VOLUNTEER_DESCRIPTION_MAX_LENGTH = 1000;
export const ACTIVITY_STATUS = ["NEW", "INACTIVE", "ACTIVE", "LEGACY"] as const;

export const PARTICIPANT_STATUS = ["APPROVED", "DECLINED", "PENDING"] as const;

export const PARTICIPANT_STATUS_HEB: Record<
  (typeof PARTICIPANT_STATUS)[number],
  string
> = {
  APPROVED: "מאושר",
  PENDING: "ממתין לאישור",
  DECLINED: "נדחה",
};



export const GET_IMAGE_URL_BASE = "/static";

/**
 * נתיב בסיס ל-webhook CDR של Voicenter (Nest HTTP).
 * URL מלא לרישום ב-Voicenter (HTTPS):
 * `https://<host-ציבורי>/integrations/voicenter/cdr/<VOICENTER_CDR_WEBHOOK_TOKEN>`
 * - אותו ערך כמו ב-env `VOICENTER_CDR_WEBHOOK_TOKEN` (אל תשתף את ה-URL בלוגים).
 */
export const VOICENTER_CDR_WEBHOOK_PATH_PREFIX = "/integrations/voicenter/cdr";

/**
 * נתיב בסיס ל־Voicenter Screen Pop (הקפצת מסך / חיפוש איש קשר).
 * URL לרישום בתוסף:
 * `https://<host-ציבורי>/integrations/voicenter/screen-pop/<TOKEN>?phone=…`
 * - `VOICENTER_SCREEN_POP_WEBHOOK_TOKEN` (או אם לא הוגדר: אותו ערך כמו `VOICENTER_CDR_WEBHOOK_TOKEN`).
 */
export const VOICENTER_SCREEN_POP_WEBHOOK_PATH_PREFIX =
  "/integrations/voicenter/screen-pop";

/**
 * Chatwoot inbound webhook (Nest HTTP). Register this URL in Chatwoot:
 * `https://<public-host>/webhooks/chatwoot`
 */
export const CHATWOOT_WEBHOOK_PATH_PREFIX = "/webhooks/chatwoot";

export function imageURL(imageId: string): string;
export function imageURL(imageId?: string | null): string | undefined;
export function imageURL(imageId?: string | null): string | undefined {
  return imageId !== null && imageId !== undefined && imageId !== ""
    ? `${ENV.serverBaseUrl}${GET_IMAGE_URL_BASE}/${imageId}`
    : undefined;
}

/** Same-origin `/static/:id` so admin.we-me.app is not blocked by ORB vs www. */
export function sameOriginImageURL(imageId: string): string;
export function sameOriginImageURL(imageId?: string | null): string | undefined;
export function sameOriginImageURL(
  imageId?: string | null,
): string | undefined {
  return imageId !== null && imageId !== undefined && imageId !== ""
    ? `${GET_IMAGE_URL_BASE}/${imageId}`
    : undefined;
}

// If (!globalThis.process) {
//   // Sync the import.meta.env with process.env for client vite apps
//   // @ts-expect-error
//   globalThis.process = { env: import.meta.env };
// }

// export const isProduction = process.env.MODE === "production";

export const WEME_ORGANIZATION_ID = "eb9ed335-7079-4483-8246-4318f269b49e";

//PRODUCTION --> "05d648d3-e666-448d-8625-02202aae3306"

/**
 * Time window (in hours) in which we ask users to submit "execution reports"
 * (post-opportunity feedback / task completion report).
 *
 * Used both for:
 * - in-app survey prompt (OpportunityReport dialog)
 * - SMS reminders after the opportunity ends
 */
export const OPPORTUNITY_REPORT_WINDOW_HOURS = 24 * 5; // 5 days

// TODO: Add default image if to S3
export const DEFAULT_OPPORTUNITY_IMAGE_ID = "360cd4ba-5616-4398-a921-7da6e4a4e7aa";

export const CATEGORIES_HEB = {
  adult: "סיוע למבוגרים",
  children: "סיוע לילדים",
  maintenance: "תחזוקה",
  cleaning: "ניקיון",
  animals: "טיפול בחיות",
} as const;

export const SUB_CATEGORIES = {
  adult: ["עזרה במעבר דירה", "עזרה עם קניות", "עזרה עם טיפול רפואי"],
  children: [
    "עזרה עם שיעורי בית",
    "עזרה עם פעילויות חוץ",
    "עזרה עם טיפול רפואי",
  ],
  maintenance: ["עזרה עם תיקונים", "עזרה עם תחזוקה כללית"],
  cleaning: ["עזרה בניקיון הבית", "עזרה בניקיון חוץ"],
  animals: ["עזרה בטיפול בחיות מחמד", "עזרה עם חיות בר"],
} as const;

export const requestedOpportunitiesWhere: EntityFilter<Opportunity> = {
  status: "AID_REQUEST",
  isClosed: false,
};

export const WEEK_DAYS_HEB = {
  SUNDAY: "ראשון",
  MONDAY: "שני",
  TUESDAY: "שלישי",
  WEDNESDAY: "רביעי",
  THURSDAY: "חמישי",
  FRIDAY: "שישי",
  SATURDAY: "שבת",
} as const;


export const WEME_APP_BASE_URL = "https://www.we-me.app";
/** הנחיה למשתמש באפליקציה כשמשהו לא עובד - ווצאפ בלבד, בלי URL גולמי */
export const WEME_FORM_SUPPORT_MESSAGE = `אם משהו לא עובד - ${WEME_SUPPORT_WHATSAPP_CTA_TEXT}`;
/** Set to true to re-enable group feed, group opportunities, and related UI in the volunteer feed. */
export const ORGANIZED_GROUPS_IN_FEED_ENABLED = true;

/** After login, AuthProvider navigates here if set (e.g. group create deep link). */
export const WEME_POST_AUTH_REDIRECT_KEY = "weme-post-auth-redirect";

/** Queued deep link path before the router handler is ready (survives LiveUpdate reload). */
export const WEME_PENDING_DEEP_LINK_KEY = "weme-pending-deep-link";

export const FEED_PATH = "/search";
export const GROUP_FEED_PATH = "/search/group";
export const GROUP_REGISTER_PATH = "/group";
export const COMMUNITY_JOIN_PATH = "/community";

/** Public link for volunteers to join a community via registration. */
export function communityJoinUrl(communityId: string): string {
  return `${WEME_APP_BASE_URL}${COMMUNITY_JOIN_PATH}/${communityId}/join`;
}

/** Public link for volunteers to create a new organized group (admin copy / project link). */
export function groupCreateUrl(organizationId: string, teamId?: string): string {
  const path = teamId
    ? `${GROUP_REGISTER_PATH}/create/${organizationId}/${teamId}`
    : `${GROUP_REGISTER_PATH}/create/${organizationId}`;
  return `${WEME_APP_BASE_URL}${path}`;
}
export const USER_REQUEST_PATH = "/user-request";

/** Public link for aid seekers to open a project-scoped request flow. */
export function projectAidRequestUrl(teamId: string): string {
  return `${WEME_APP_BASE_URL}${USER_REQUEST_PATH}?teamId=${encodeURIComponent(teamId)}`;
}
export const USER_REQUEST_INTRO_PATH = "/user-request-intro";
export const GUEST_FEED_PATH = "/guest-feed";
export const OPPORTUNITY_PATH = "/opportunity";
export const SEEKER_VOLUNTEERS_PATH_SUFFIX = "volunteers";

export function buildSeekerVolunteersPath(opportunityId: string): string {
  return `${OPPORTUNITY_PATH}/${opportunityId}/${SEEKER_VOLUNTEERS_PATH_SUFFIX}`;
}
export const CHATS_PATH = "/chats";
export const WELCOME_PATH = "/welcome";
export const MY_ACTIVITY_PATH = "/my-activity";
export const NOTIFICATIONS_PATH = "/notifications";
export const SUMMER_CAMPAIGN_PATH = "/summer-campaign";
export const LOGIN_PATH = "/login";
export const JOIN_COMMUNITY_PATH = "/join-community";
export const CALL_CENTER_LEAD_PATH = "/call-center-lead";

/** קישור לטופס אישור הורים למתנדבים בגיל 16–18 (לב אחד) */
export const PARENT_CONSENT_FORM_URL =
  "https://einprat.fillout.com/t/6P6ahQXgpsus";

export const DEFAULT_REGISTRATION_BUTTON_TEXT = "אני רוצה להירשם";

export const REGISTRATION_BUTTON_TEXT_MAX_LENGTH = 200;

export const PRE_REGISTRATION_PROCESS_TEXT_MAX_LENGTH = 3000;

export function resolveRegistrationButtonText(
  text: string | null | undefined,
): string {
  const trimmed = text?.trim();
  return trimmed ? trimmed : DEFAULT_REGISTRATION_BUTTON_TEXT;
}

/** Normalizes custom registration button text before persisting (trim, empty → null). */
export function normalizeRegistrationButtonTextForStorage(
  text: string | null | undefined,
): string | undefined {
  const trimmed = text?.trim();
  if (!trimmed) return undefined;
  return trimmed.slice(0, REGISTRATION_BUTTON_TEXT_MAX_LENGTH);
}

/** Normalizes custom pre-registration process text before persisting (trim, empty → undefined). */
export function normalizePreRegistrationProcessTextForStorage(
  text: string | null | undefined,
): string | undefined {
  const trimmed = text?.trim();
  if (!trimmed) return undefined;
  return trimmed.slice(0, PRE_REGISTRATION_PROCESS_TEXT_MAX_LENGTH);
}